<template>
  <div>
    <vx-card class="w-full mb-6">
      <vs-table ref="courseTable" stripe class="vs-con-loading__container" single @selected="handleSelectedCourse" pagination :max-items="itemsPerPage" search :data="courses" v-scroll-to="'#courseInfoCard'">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showDetailsCard" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>

          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ courses.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : courses.length }} of {{ courses.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="description">Description</vs-th>
          <vs-th sort-key="languageName">Language</vs-th>
          <vs-th sort-key="classificationName">{{ $siteTypeId() == 1 ? 'Grade' : 'Classification' }}</vs-th>
          <vs-th sort-key="modifiedOn">Modified On</vs-th>
          <vs-th sort-key="modifiedBy">Modified By</vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="course" :key="indextr" v-for="(course, indextr) in data">

            <vs-td :data="data[indextr].name">
              {{ course.name }}
            </vs-td>

            <vs-td :data="data[indextr].description">
              {{ course.description }}
            </vs-td>

            <vs-td :data="data[indextr].languageName">
              {{ course.languageName ? course.languageName : 'N/A' }}
            </vs-td>

            <vs-td :data="data[indextr].classificationName">
              {{ course.classificationName ? course.classificationName : 'N/A' }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedOn">
              {{ course.modifiedOn.replace("T", " ").split('.')[0] }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedBy">
              {{ course.modifiedBy }}
            </vs-td>
            
            <vs-td>
              <vs-chip v-show="course.isReadOnly" color="success">Inherited</vs-chip>
            </vs-td>

            <vs-td>
                  <div class="flex">
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" :disabled="data[indextr].isReadOnly || !data[indextr].number" line-origin="right"  icon="icon-arrow-up" @click.prevent="moveCourseUp(data[indextr].id)"></vs-button>
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" :disabled="data[indextr].isReadOnly || data[indextr].id == courses[courses.length - 1].id" line-origin="left"  icon="icon-arrow-down" @click.prevent="moveCourseDown(data[indextr].id)"></vs-button>
                  </div>
              </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card id="courseInfoCard" ref="courseInfo" class="mb-6" :title="courseCardTitle" v-show="!isInfoHidden">
      <div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Name</label>
            <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Name" v-model="formData.name" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Description</label>
            <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Description" v-model="formData.description" />
            <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
          </div>
        </div>
        <div v-if="$siteTypeId() == 1 && !isCourseReadOnly" class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Language</label>
            <v-select ref="languageDropdown" class="w-full" placeholder="Search / Select Language" :options="languages" v-model="languageDropdown"></v-select>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>{{ $siteTypeId() == 1 ? 'Grade' : 'Course Classification' }}</label>
            <v-select ref="classificationDropdown" class="w-full" :placeholder="$siteTypeId() == 1 ? 'Search / Select Grade' : 'Search / Select Course Classification'" :options="classifications" v-model="classificationDropdown"></v-select>
          </div>
        </div>
        <div v-if="$siteTypeId() == 1 && isCourseReadOnly" class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Language</label>
            <vs-input autocomplete="off" :disabled="true" class="w-full" v-model="formData.languageName" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>{{ $siteTypeId() == 1 ? 'Grade' : 'Course Classification' }}</label>
            <vs-input autocomplete="off" :disabled="true" class="w-full" v-model="formData.classificationName" />
          </div>
        </div>
        <div class="vx-row pb-3" v-if="$siteTypeId() == 1" >
          <div class="vx-col sm:w-1/2 w-full mb-2 flex-row flex">
            <vs-checkbox :disabled="isCourseReadOnly" v-model="formData.isCore">Core</vs-checkbox>
            <vs-checkbox :disabled="isCourseReadOnly" v-model="formData.isElective">Elective</vs-checkbox>
          </div>
        </div>
      </div>
      <div v-if="this.$siteTypeId() != 1">
        <div v-show="formData.id">
          <vs-divider>Course Outcomes</vs-divider>

          <vs-collapse class="border mb-2">
            <vs-collapse-item>
              <div slot="header">
                Essential Embedded Knowledge
              </div>
              <div class="w-full" v-show="showEssentialEmbeddedKnowledgeList">
                <vx-card id="courseOutcomeCard" ref="courseOutcome">        
                  <vs-table stripe ref="classificationsTable" class="vs-con-loading__container" single @selected="handleSelectedEssentialEmbeddedKnowledge" pagination max-items="10" search :data="EssentialEmbeddedKnowledgeList"> 
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                      <!-- ADD NEW -->
                      <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addEssentialEmbeddedKnowledgeList">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New</span>
                      </div>
                    </div>
                    <template slot="thead">
                      <vs-th sort-key="name">Name</vs-th>
                      <vs-th sort-key="description">Description</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="EssentialEmbeddedKnowledgeList" :key="indextr" v-for="(EssentialEmbeddedKnowledgeList, indextr) in data" >

                        <vs-td :data="data[indextr].name">
                          {{ EssentialEmbeddedKnowledgeList.name }}
                        </vs-td>

                        <vs-td :data="data[indextr].description">
                          {{ EssentialEmbeddedKnowledgeList.description }}
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
              <div v-show="addNewEssentialEmbeddedKnowledge">
                <div class="vx-row pb-3">
                  <div class="vx-col sm:w-1/2 w-full">
                    <label>Name</label>
                    <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" name="Name" v-model="essentialEmbeddedKnowledgeName" />
                    <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <label>Description</label>
                    <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" name="Description" v-model="essentialEmbeddedKnowledgeDescription" />
                    <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
                  </div>
                </div>
                <div class="vx-row mt-3">
                  <vs-spacer></vs-spacer>
                  <div class="vx-col">
                      <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container vx-col" :disabled="isDisabled" @click.prevent="saveEEK" ref="saveEditButton">Save</vs-button>
                      <vs-button color="danger" v-show="selectedEssentialEmbeddedKnowledgeId" class="mr-5 mb-2 vs-con-loading__container vx-col" @click.prevent="deleteEEK" ref="deleteButton">Delete</vs-button>
                      <vs-button color="warning" type="border" class="mb-2"  @click="cancelEssentialEmbeddedKnowledgeAdd">Cancel</vs-button>
                  </div>
                </div>
              </div>

            </vs-collapse-item>
          </vs-collapse>

          <vs-collapse class="border mb-2">
            <vs-collapse-item>
              <div slot="header">
                Unit Standards
              </div>
              <div class="w-full" v-show="showUnitStandardsList">
                <vx-card id="courseOutcomeCard" ref="courseOutcome">        
                  <vs-table stripe ref="classificationsTable" class="vs-con-loading__container" single @selected="handleSelectedUnitStandards" pagination max-items="10" search :data="unitStandardsList"> 
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                      <!-- ADD NEW -->
                      <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addUnitStandardsList">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New</span>
                      </div>
                    </div>
                    
                    <template slot="thead">
                      <vs-th sort-key="name">Name</vs-th>
                      <vs-th sort-key="description">Description</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="unitStandardsList" :key="indextr" v-for="(unitStandardsList, indextr) in data" >

                        <vs-td :data="data[indextr].name">
                          {{ unitStandardsList.name }}
                        </vs-td>

                        <vs-td :data="data[indextr].description">
                          {{ unitStandardsList.description }}
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            <div v-show="addUnitStandards">
              <div class="vx-row pb-3">
                <div class="vx-col sm:w-1/2 w-full">
                  <label>Name</label>
                  <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" name="Name" v-model="unitStandardsName" />
                  <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <label>Description</label>
                  <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" name="Description" v-model="unitStandardsDescription" />
                  <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
                </div>
              </div>
            
              <div class="vx-row mt-3">
                <vs-spacer></vs-spacer>
                <div class="vx-col">
                    <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveUnitStandards" ref="saveEditButton">Save</vs-button>
                    <vs-button color="danger" v-show="selectUnitStandardId" class="mr-2 mb-2 vs-con-loading__container" @click.prevent="deleteUnitStandards" ref="deleteButton">Delete</vs-button>
                    <vs-button color="warning" type="border" class="mb-2"  @click="cancelUnitStandardsAdd">Cancel</vs-button>
                </div>
              </div>
            </div>
            </vs-collapse-item>
          </vs-collapse>

          <vs-collapse class="border mb-2">
            <vs-collapse-item>
              <div slot="header">
                Assessment Criteria
              </div>

              <div class="w-full" v-show="showAsessmentCriteriaList">
                <vx-card id="courseOutcomeCard" ref="courseOutcome">        
                  <vs-table stripe ref="classificationsTable" class="vs-con-loading__container" single @selected="handleAsessmentCriteria" pagination max-items="10" search :data="asessmentCriteriaList"> 
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                      <!-- ADD NEW -->
                      <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addAsessmentCriteriaList">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New</span>
                      </div>
                    </div>
                    
                    <template slot="thead">
                      <vs-th sort-key="name">Name</vs-th>
                      <vs-th sort-key="description">Description</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="asessmentCriteriaList" :key="indextr" v-for="(asessmentCriteriaList, indextr) in data" >

                        <vs-td :data="data[indextr].name">
                          {{ asessmentCriteriaList.name }}
                        </vs-td>

                        <vs-td :data="data[indextr].description">
                          {{ asessmentCriteriaList.description }}
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            <div v-show="addAsessmentCriteria">
              <div class="vx-row pb-3">
                <div class="vx-col sm:w-1/2 w-full">
                  <label>Name</label>
                  <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" name="Name" v-model="asessmentCriteriaName" />
                  <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <label>Description</label>
                  <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full" name="Description" v-model="asessmentCriteriaDescription" />
                  <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
                </div>
              </div>

                <div class="vx-row mt-3">
                  <vs-spacer></vs-spacer>
                  <div class="vx-col">
                    <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveAsessmentCriteria" ref="saveEditButton">Save</vs-button>
                    <vs-button color="danger" v-show="selectedAsessmentCriteriaId" class="mr-2 mb-2 vs-con-loading__container" @click.prevent="deleteAsessmentCriteria" ref="deleteButton">Delete</vs-button>
                    <vs-button color="warning" type="border" class="mb-2"  @click="cancelAsessmentCriteriaAdd">Cancel</vs-button>
                  </div>
                </div>
              </div>
              
            </vs-collapse-item>
          </vs-collapse>

          <vs-collapse class="border mb-2">
            <vs-collapse-item>
              <div slot="header">
                Specific Outcome
              </div>
              <div class="w-full" v-show="showSpecificOutcomeList">
                <vx-card id="courseOutcomeCard" ref="courseOutcome">        
                  <vs-table stripe ref="classificationsTable" class="vs-con-loading__container" single @selected="handleSpecificOutcome" pagination max-items="10" search :data="specificOutcomeList"> 
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                      <!-- ADD NEW -->
                      <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addSpecificOutcomeList">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New</span>
                      </div>
                    </div>
                    
                    <template slot="thead">
                      <vs-th sort-key="name">Name</vs-th>
                      <vs-th sort-key="description">Description</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="specificOutcomeList" :key="indextr" v-for="(specificOutcomeList, indextr) in data" >

                        <vs-td :data="data[indextr].name">
                          {{ specificOutcomeList.name }}
                        </vs-td>

                        <vs-td :data="data[indextr].description">
                          {{ specificOutcomeList.description }}
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
                </div>
            <div v-show="addSpecificOutcome">
              <div class="vx-row pb-3">
                <div class="vx-col sm:w-1/2 w-full">
                  <label>Name</label>
                  <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full"  name="Name" v-model="specificOutcomeName" />
                  <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <label>Description</label>
                  <vs-input :disabled="isCourseReadOnly" autocomplete="off" onClick="this.select();" class="w-full"  name="Description" v-model="specificOutcomeDescription" />
                  <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
                </div>
              </div>

              <div class="vx-row mt-3">
                <vs-spacer></vs-spacer>
                <div class="vx-col">
                    <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveSpecificOutcome" ref="saveEditButton">Save</vs-button>
                    <vs-button color="danger" v-show="selectedSpecificOutcomeId" class="mr-2 mb-2 vs-con-loading__container" @click.prevent="deleteSpecificOutcome" ref="deleteButton">Delete</vs-button>
                    <vs-button color="warning" type="border" class="mb-2"  @click="cancelSpecificOutcomeAdd">Cancel</vs-button>
                </div>
              </div>
            </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </div>
        <div v-show="formData.id && $siteTypeId() == 1">
          <vs-divider>{{ $siteTypeId() == 1 ? 'Modules' : 'Module Categories' }}</vs-divider>
          <module-category :isCardActive="moduleCategory" :sourceCourseId="sourceCourseId" :isCourseReadOnly="isCourseReadOnly"/>
        </div>
      <div v-show="formData.id">
        <vs-divider class="mb-6 pt-3">{{ $siteTypeId() == 1 ? 'Topics' : 'Modules' }}</vs-divider>
        <vs-table ref="moduleTable" stripe class="vs-con-loading__container" single @selected="handleSelectedModule" pagination max-items="10" search :data="modules">
          <div v-if="!isCourseReadOnly" slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center">
              <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showModuleCard" >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                <span class="ml-2 text-base text-primary">Add New {{ $siteTypeId() == 1 ? 'Topic' : 'Module' }}</span>
              </div>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="id">ID</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <!-- <vs-chip v-show="true" color="success">Linked To Module</vs-chip> -->
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="moduleCategoryId">{{ $siteTypeId() == 1 ? 'Module' : 'Category' }}</vs-th>
            <vs-th sort-key="moduleGroupId">{{ $siteTypeId() == 1 ? 'Term' : 'Group' }}</vs-th>
            <vs-th sort-key="price">Price</vs-th>
            <vs-th sort-key="coinCount">Total Coins</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="isCourseModuleViewActive" :key="indextr" v-for="(isCourseModuleViewActive, indextr) in data">

              <vs-td :data="data[indextr].id">
                {{ isCourseModuleViewActive.id }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ isCourseModuleViewActive.name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ isCourseModuleViewActive.description }}
              </vs-td>

              <vs-td :data="data[indextr].moduleCategoryName">
                {{ isCourseModuleViewActive.moduleCategoryName ? isCourseModuleViewActive.moduleCategoryName : "N/A" }}
              </vs-td>

              <vs-td :data="data[indextr].moduleGroupName">
                {{ isCourseModuleViewActive.moduleGroupName ? isCourseModuleViewActive.moduleGroupName : "N/A" }}
              </vs-td>

              <vs-td :data="data[indextr].price">
                {{ isCourseModuleViewActive.price ? "R " + Number(isCourseModuleViewActive.price).toLocaleString('en') : 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].coinCount">
                {{ isCourseModuleViewActive.coinCount ? isCourseModuleViewActive.coinCount : "N/A" }} <!-- Ѫ -->
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ isCourseModuleViewActive.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modiefiedBy">
                {{ isCourseModuleViewActive.modifiedBy }}
              </vs-td>

              <vs-td>
                  <div class="flex">
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="right" :disabled="data[indextr].number == 1" icon="icon-arrow-up" @click="moveIndexUp(data[indextr].id)"></vs-button>
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="left"  :disabled="getLastIndex(data[indextr].number)" icon="icon-arrow-down" @click="moveIndexDown(data[indextr].id)"></vs-button>
                  </div>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div v-if="!isCourseReadOnly" class="vx-row mt-3">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <div v-show="!defaultButtonsHidden">
            <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveEditCourse" ref="saveEditButton">Save</vs-button>
            <vs-button color="danger" v-show="formData.id" class="mr-5 mb-2 vs-con-loading__container" @click.prevent="validateDelete" ref="deleteButton">Delete</vs-button>
            <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#courseInfoCard'" @click="cancelAdd">Cancel</vs-button>
          </div>
          <div v-show="defaultButtonsHidden">
            <vs-button color="success" class="mb-2" v-scroll-to="'#courseInfoCard'" @click="cancelAdd">Close</vs-button>
          </div>
        </div>
      </div>
      <div v-else class="vx-row mt-3">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#courseInfoCard'" @click="cancelAdd">Close</vs-button>
        </div>
      </div>
    </vx-card>

    <course-module  :isCardActive="isCourseModuleViewActive"
                    @closeCard="isCourseModuleViewActive = false"
                    :moduleSelected="selectedModule"
                    :sourceCourseId="sourceCourseId"
                    @saveData="dataSaved"
                    @loadModules="loadModules"
                    :moduleCardTitle="moduleCardTitle"
                    :isCourseReadOnly="isCourseReadOnly"/>

  </div>
</template>

<script>
  import courseModule from './CourseModule.vue';
  import moduleCategory from './ModuleCategory.vue';
  import vSelect from 'vue-select';

  export default {
    components: {
      courseModule,
      moduleCategory,
      'v-select': vSelect
    },
    data() {
      return {
        isCourseModuleViewActive: false,
        moduleCategory: false,
        sourceCourseId: 0,
        loadingColor:'#fff',
        selected: [],
        itemsPerPage: 10,
        isMounted: false,
        isInfoHidden: true,
        courses: [],
        modules: [],
        formData: {
          id: 0,
          languageId: null,
          courseClassificationId: null,
          name: "",
          description: "",
          languageName: "",
          classificationName: "",
          isCore:false,
          isElective:false,
        },
        selectedModule: {},
        mode: "",
        defaultButtonsHidden: false,
        moduleCardTitle: "",
        courseCardTitle: "",
        languageDropdown: 0,
        classificationDropdown: 0,
        languages: [],
        classifications: [],
        isCourseReadOnly: false,
        essentialEmbeddedKnowledgeName: "",
        essentialEmbeddedKnowledgeDescription: "",
        selectedEssentialEmbeddedKnowledgeId: 0,
        unitStandardsName: "",
        unitStandardsDescription: "",
        asessmentCriteriaName: "",
        asessmentCriteriaDescription: "",
        specificOutcomeName: "",
        specificOutcomeDescription: "",
        EssentialEmbeddedKnowledgeList: [],
        unitStandardsList: [],
        asessmentCriteriaList: [],
        specificOutcomeList: [],
        addNewEssentialEmbeddedKnowledge: false,
        showEssentialEmbeddedKnowledgeList: false,
        showUnitStandardsList: false,
        addUnitStandards:false,
        selectUnitStandardId: 0,
        showAsessmentCriteriaList: false,
        addAsessmentCriteria: false,
        selectedAsessmentCriteriaId: 0,
        selectedSpecificOutcomeId: 0,
        addSpecificOutcome: false,
        showSpecificOutcomeList: false,
        indexButtonClicked:false
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.courseTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.name && this.formData.description);
      },
      
    },
    watch:{
      'formData.isCore':function() {
        var self = this;
        if(self.formData.isCore){
          self.formData.isElective = false
        }
      },
      'formData.isElective':function() {
        var self = this;
        if(self.formData.isElective){
          self.formData.isCore = false
        }
      },
    },
    methods: {
      getLastIndex(index){
        var self = this;
        if(self.modules[self.modules.length -1].number == index){
          return true;
        }
        else 
        return false;
      },
      initModuleCard(id, mode) {
        this.isCourseModuleViewActive = false;
        this.moduleCardTitle = mode == "Add" ? `New ${ this.$siteTypeId() == 1 ? 'Topic' : 'Module' }` : this.isCourseReadOnly ? `View ${ this.$siteTypeId() == 1 ? 'Topic' : 'Module' }` : `Edit ${ this.$siteTypeId() == 1 ? 'Topic' : 'Module' }`;

        if(mode == "Add")
          this.selectedModule = {};

        if(!isNaN(id))
          this.sourceCourseId = id;
        
        setTimeout(() => {
          this.isCourseModuleViewActive = true;
        }, 50);
      },
      initCourseValues() {
        this.formData.id = 0;
        this.formData.name = "";
        this.formData.description = "";
        this.formData.languageId = null;
        this.formData.courseClassificationId = null;
        this.languageDropdown = 0;
        this.classificationDropdown = 0;
        this.mode = "";
        this.isCourseReadOnly = false;
        this.errors.clear();
      },
      getLanguages() {
        var self = this;

        var onSuccess = response => {
          self.languages = response.data.map((item) => {return {label: item.text, value: item.value} });
        };
        
        self.$ajaxGet(self, "language/GetSelectList", onSuccess);
      },
      getClassifications() {
        var self = this;

        var onSuccess = response => {
          self.classifications = response.data.map((item) => {return {label: item.text, value: item.value} });
        };
        
        self.$ajaxGet(self, "courseclassification/GetSelectList", onSuccess);
      },
      cancelAdd() {
        this.initCourseValues();
        this.isInfoHidden = true;
        this.isCourseModuleViewActive = false;
        this.moduleCategory = false;
      },
      saveData() {
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      dataSaved(mode){
        if(mode != "Add")
          this.isCourseModuleViewActive = false;
        this.loadModules();
      },
      loadData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.courses = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.courseTable.$el);
        };

        self.$ajaxGet(self, "course/listcourses", onSuccess, onFinally);
      },
      showDetailsCard(){
        var self = this;
        self.errors.clear();
        self.initCourseValues();
        self.modules = [];
        self.isInfoHidden = false;
        self.defaultButtonsHidden = false;
        self.mode = "Add New";
        self.courseCardTitle = self.$siteTypeId() == 1 ? "Add Subject" : "Add Course";
      },
      handleSelectedCourse(course) {
        var self = this;
        if(self.indexButtonClicked){
          return
        }
        self.cancelAdd();
        self.defaultButtonsHidden = false;
        self.isInfoHidden = false;
        setTimeout(() => {
          self.modules = [];
          self.isCourseModuleViewActive = false;
          self.mode = "Update";
          self.courseCardTitle = self.$siteTypeId() == 1 ? "Edit Subject" : "Edit Course";
          self.formData.id = course.id;
          self.loadModules();
          self.formData.name = course.name;
          self.formData.description = course.description;
          self.languageDropdown = self.languages.filter(function(item){return item.value == course.languageId;})[0];
          self.classificationDropdown = self.classifications.filter(function(item){return item.value == course.courseClassificationId;})[0];
          self.sourceCourseId = course.id;
          self.moduleCategory = true;
          self.formData.languageName = course.languageName;
          self.formData.classificationName = course.classificationName;
          self.formData.isCore = course.isCore;
          self.formData.isElective = course.isElective;
          self.isCourseReadOnly = course.isReadOnly ? true : false;
          self.courseCardTitle = self.isCourseReadOnly ? self.$siteTypeId() == 1 ? 'View Subject' : 'View Course' : self.$siteTypeId() != 1 ? "Edit Course" : "Edit Subject";
          self.EssentialEmbeddedKnowledgeList = [];
          self.asessmentCriteriaList= [];
          self.unitStandardsList= [];
          self.specificOutcomeList= [];
          self.getEEK();
          self.getAC();
          self.getUS();
          self.getSO();
        }, 50);
      },
      getEEK(){
        var self = this;
        var onSuccess = function (response) {
          if(response.data.length != 0){           
            self.EssentialEmbeddedKnowledgeList = response.data;
          }         
        };

        self.$ajaxGet(self, "Course/ListEEK?courseId=" + self.formData.id, onSuccess)
      },
      getAC(){
        var self = this;
        var onSuccess = function (response) {
          if(response.data.length != 0){
            self.asessmentCriteriaList = response.data;
          }          
        };

        self.$ajaxGet(self, "Course/ListAC?courseId=" + self.formData.id, onSuccess)
      },
      getUS(){
        var self = this;
        var onSuccess = function (response) {
          if(response.data.length != 0){
          self.unitStandardsList = response.data;
          }
        };

        self.$ajaxGet(self, "Course/ListUS?courseId=" + self.formData.id, onSuccess)
      },
      getSO(){
        var self = this;
        var onSuccess = function (response) {
          if(response.data.length != 0){
            
            self.specificOutcomeList = response.data;
          }          
        };

        self.$ajaxGet(self, "Course/ListSO?courseId=" + self.formData.id, onSuccess)
      },
      saveEditCourse() {
        var self = this;
        
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnSaveButton();
            self.formData.languageId = self.languageDropdown ? parseInt(self.languageDropdown.value) : null;
            self.formData.courseClassificationId = self.classificationDropdown ? parseInt(self.classificationDropdown.value) : null;

            var onSuccess = response => {
              self.sourceCourseId = response.data;
              self.formData.id = response.data;
              self.saveData();
              self.moduleCategory = true;
              if(self.mode != "Add New"){
                self.isInfoHidden = true;
                self.initCourseValues();
              }else
                self.defaultButtonsHidden = true;

              self.cancelAdd();

              self.$vs.notify({
                title:'Information',
                color: "success",
                text: `${self.$siteTypeId() == 1 ? 'Subject' : 'Course'} Saved`,
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };
            self.$ajaxPost(self, "course/addeditcourse", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      validateDelete() {
        if(this.modules.length > 0)
          this.openConfirm();
        else
          this.deleteCourse();
      },
      openConfirm() {
        var self = this;
        self.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Attention`,
          text: `Are you sure you want to delete the selected ${ self.$siteTypeId() == 1 ? 'subject' : 'course' } and ALL of its associated ${ self.$siteTypeId() == 1 ? 'topics' : 'modules' }? \n\nNote: This cannot be undone.`,
          accept: self.deleteCourse,
          acceptText: "Yes, delete",
          cancelText: "No, cancel"
        })
      },
      deleteCourse() {
        var self = this;
        self.showLoadingOnDeleteButton();

        var onSuccess = response => {
          self.saveData();
          self.initCourseValues();
          self.errors.clear();
          self.isInfoHidden = true;
          self.scrollToNavbar();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `${self.$siteTypeId() == 1 ? 'Subject' : 'Course'} Deleted`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };

        self.$ajaxDelete(self, "Course/DeleteCourse/" + self.formData.id, onSuccess, onFinally);
      },
      handleSelectedModule(isCourseModuleViewActive){
        var self = this;
        if(!self.indexButtonClicked){
          self.isCourseModuleViewActive = false;
          setTimeout(function(){
            self.selectedModule = {};
            self.selectedModule = isCourseModuleViewActive;
            self.errors.clear();
            self.initModuleCard(self.formData.id, "Edit");
            self.scrollToModuleInfo();  
          },100);
        }
        self.indexButtonClicked = false;
      },
      showModuleCard(){

        var self = this;
        self.errors.clear();
        self.initModuleCard(self.formData.id, "Add");
        self.scrollToModuleInfo();
      },
      loadModules(){
        const self = this;
        self.$vs.loading.close(self.$refs.moduleTable.$el);
        self.showLoadingOnModulesTable();

        var onSuccess = function (response) {
          self.modules = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.moduleTable.$el);
        };

        self.$ajaxGet(self, "module/listcoursemodule/" + self.formData.id, onSuccess, onFinally);
      },
      showLoadingOnSaveButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveEditButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnsaveModuleButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveModuleButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.courseTable.$el,
          scale: 1
        });
      },
      showLoadingOnModulesTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.moduleTable.$el,
          scale: 1
        });
      },
      showLoadingOnCourseInfoCard(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.courseInfo.$el,
          scale: 1
        });
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.deleteButton.$el,
          scale: 0.45
        });
      },
      scrollToModuleInfo() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: 2200,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("moduleInfoCard"), 500, scrollOptions);
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      saveEEK(){
        var self = this;

        var Eek = {
          id: self.selectedEssentialEmbeddedKnowledgeId,
          courseId: self.formData.id,
          name: self.essentialEmbeddedKnowledgeName,
          description: self.essentialEmbeddedKnowledgeDescription,
        };

        var onSuccess = response => {
          
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: 'Essential Embedded Knowledge added',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
          self.cancelEssentialEmbeddedKnowledgeAdd();
          self.getEEK();
        };

        self.$ajaxPost(self, "Course/AddUpdateEEK", Eek, onSuccess); 
      },
      deleteEEK(){
        var self = this;
        var onSuccess = response => {
          self.essentialEmbeddedKnowledgeName = "";
          self.essentialEmbeddedKnowledgeDescription = "";
          self.EssentialEmbeddedKnowledgeList = [];
          self.getEEK();
          self.cancelEssentialEmbeddedKnowledgeAdd();
          self.$vs.notify({
            title:'Information',
            color: "warning",
            text: 'Essential Embedded Knowledge Deleted',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };

        self.$ajaxGet(self, "Course/DeleteEEK?Id=" + self.selectedEssentialEmbeddedKnowledgeId, onSuccess); 
      },
      saveAsessmentCriteria(){
        var self = this;

        var AsessmentCriteria = {
          id: self.selectedAsessmentCriteriaId,
          courseId: self.formData.id,
          name: self.asessmentCriteriaName,
          description: self.asessmentCriteriaDescription,
        };

        var onSuccess = response => {
          self.cancelAsessmentCriteriaAdd();
          self.getAC();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: 'Assessment Criteria saved',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };

        self.$ajaxPost(self, "Course/AddUpdateAC", AsessmentCriteria, onSuccess); 
      },
      deleteAsessmentCriteria(){
        var self = this;

        var onSuccess = response => {
          self.asessmentCriteriaName = "";
          self.asessmentCriteriaDescription = "";
          self.asessmentCriteriaList= [];
          self.cancelAsessmentCriteriaAdd();
          self.getAC();

          self.$vs.notify({
            title:'Information',
            color: "warning",
            text: 'Assessment Criteria Deleted',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };

        self.$ajaxGet(self, "Course/DeleteAC?Id=" + self.selectedAsessmentCriteriaId, onSuccess); 
      },
      saveSpecificOutcome(){
        var self = this;

        var SpecificOutcome = {
          id: self.selectedSpecificOutcomeId,
          courseId: self.formData.id,
          name: self.specificOutcomeName,
          description: self.specificOutcomeDescription,
        };

        var onSuccess = response => {
          self.cancelSpecificOutcomeAdd();
          self.getSO();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: 'Specific Outcome added',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };

        self.$ajaxPost(self, "Course/AddUpdateSO", SpecificOutcome, onSuccess); 
      },
      deleteSpecificOutcome(){
        var self = this;

        var onSuccess = response => {
          self.specificOutcomeList= [];
          self.specificOutcomeName = "";
          self.specificOutcomeDescription = "";
          self.cancelSpecificOutcomeAdd();
          self.getSO();

          self.$vs.notify({
            title:'Information',
            color: "warning",
            text: 'Specific Outcome Deleted',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };

        self.$ajaxGet(self, "Course/DeleteSO?Id=" + self.selectedSpecificOutcomeId, onSuccess); 
      },
      saveUnitStandards(){
        var self = this;

        var UnitStandards = {
          id: self.selectUnitStandardId,
          courseId: self.formData.id,
          name: self.unitStandardsName,
          description: self.unitStandardsDescription,
        };

        var onSuccess = response => {
          self.cancelUnitStandardsAdd();
          self.getUS();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: 'Unit Standard added',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };

        self.$ajaxPost(self, "Course/AddUpdateUS", UnitStandards, onSuccess); 
      },
      deleteUnitStandards(){
        var self = this;

        var onSuccess = response => {
          self.unitStandardsList= [];
          self.cancelUnitStandardsAdd();
          self.getUS();
          self.unitStandardsName = "";
          self.unitStandardsDescription = "";

          self.$vs.notify({
            title:'Information',
            color: "warning",
            text: 'Unit Standards Deleted',
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };

        self.$ajaxGet(self, "Course/DeleteUS?Id=" + self.selectUnitStandardId, onSuccess); 
      },
      handleSelectedEssentialEmbeddedKnowledge(EssentialEmbeddedKnowledge){
        var self = this;
        
        self.showEssentialEmbeddedKnowledgeList = false;
        self.addNewEssentialEmbeddedKnowledge = true;

        self.essentialEmbeddedKnowledgeName = EssentialEmbeddedKnowledge.name;
        self.essentialEmbeddedKnowledgeDescription = EssentialEmbeddedKnowledge.description;
        self.selectedEssentialEmbeddedKnowledgeId = EssentialEmbeddedKnowledge.id;
      },
      addEssentialEmbeddedKnowledgeList(){
        var self = this;
        
        self.showEssentialEmbeddedKnowledgeList = false;
        self.addNewEssentialEmbeddedKnowledge = true;

        self.essentialEmbeddedKnowledgeName = "";
        self.essentialEmbeddedKnowledgeDescription = "";
        self.selectedEssentialEmbeddedKnowledgeId = 0;
      },
      cancelEssentialEmbeddedKnowledgeAdd(){
        var self = this;
        self.selectedEssentialEmbeddedKnowledgeId = 0;
        self.showEssentialEmbeddedKnowledgeList = true;
        self.addNewEssentialEmbeddedKnowledge = false;
      },
      handleSelectedUnitStandards(unitStandards){
        var self = this;
        self.showUnitStandardsList= false;
        self.addUnitStandards = true; 

        self.unitStandardsName = unitStandards.name;
        self.unitStandardsDescription = unitStandards.description;
        self.selectUnitStandardId = unitStandards.id;

      },
      addUnitStandardsList(){
        var self = this;

        self.showUnitStandardsList= false;
        self.addUnitStandards = true;
        
        self.unitStandardsName = "";
        self.unitStandardsDescription = "";
        self.selectUnitStandardId = 0;
      },
      cancelUnitStandardsAdd(){
        var self = this;

        self.selectUnitStandardId = 0;
        self.showUnitStandardsList= true;
        self.addUnitStandards = false;
      },
      handleAsessmentCriteria(asessmentCriteria){
        var self = this;

        self.showAsessmentCriteriaList= false;
        self.addAsessmentCriteria = true; 

        self.asessmentCriteriaName = asessmentCriteria.name;
        self.asessmentCriteriaDescription = asessmentCriteria.description;
        self.selectedAsessmentCriteriaId = asessmentCriteria.id;
      },
      addAsessmentCriteriaList(){
        var self = this;

        self.showAsessmentCriteriaList= false;
        self.addAsessmentCriteria = true;
        
        self.asessmentCriteriaName = "";
        self.asessmentCriteriaDescription = "";
        self.selectedAsessmentCriteriaId = 0;
      },
      cancelAsessmentCriteriaAdd(){
        var self = this;

        self.selectedAsessmentCriteriaId = 0;
        self.showAsessmentCriteriaList= true;
        self.addAsessmentCriteria = false;
      },
      handleSpecificOutcome(specificOutcome){
        var self = this;

        self.showSpecificOutcomeList= false;
        self.addSpecificOutcome = true; 

        self.specificOutcomeName = specificOutcome.name;
        self.specificOutcomeDescription = specificOutcome.description;
        self.selectedSpecificOutcomeId = specificOutcome.id;
      },
      addSpecificOutcomeList(){
        var self = this;

        self.showSpecificOutcomeList= false;
        self.addSpecificOutcome = true;
        
        self.specificOutcomeName = "";
        self.specificOutcomeDescription = "";
        self.selectedSpecificOutcomeId = 0;
      },
      cancelSpecificOutcomeAdd(){
        var self = this;

        self.selectedSpecificOutcomeId = 0;
        self.showSpecificOutcomeList= true;
        self.addSpecificOutcome = false;
      },
      moveIndexUp(moduleId){
        var self = this;
        if(!self.indexButtonClicked){
          self.indexButtonClicked = true;
          var onSuccess = response =>{
            self.loadModules();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: `Module list order Updated`,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          self.$ajaxGet(self, `Module/MoveModuleUp?courseId=${self.sourceCourseId}&moduleId=${moduleId}`,onSuccess);
        }
      },
      moveIndexDown(moduleId){
        var self = this;
        if(!self.indexButtonClicked){
          self.indexButtonClicked = true;
          var onSuccess = response =>{
            self.loadModules();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: `Module list order Updated`,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          self.$ajaxGet(self, `Module/MoveModuleDown?courseId=${self.sourceCourseId}&moduleId=${moduleId}`,onSuccess);
          }
      },
      moveCourseUp(courseId){
        var self = this;
        self.indexButtonClicked = true;
        var swapcourseIndex = self.courses.filter(y=>!y.isReadOnly).findIndex(x=>x.id == courseId);
        if(!swapcourseIndex){
          self.indexButtonClicked = false;
          return
        }
        var swapcourseId = self.courses.filter(y=>!y.isReadOnly)[swapcourseIndex - 1].id;
        var onSuccess = response =>{

          self.loadData();

        }
        var onFinally = response =>{
          self.indexButtonClicked = false;
          self.$vs.notify({
              title:'Information',
              color: "success",
              text: `Order change saved`,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
        }
        self.$ajaxGet(self, `Course/MoveIndexCourse?courseId=${courseId}&swapCourseId=${swapcourseId}`  , onSuccess, onFinally);
      },
      moveCourseDown(courseId){
        var self = this;
        self.indexButtonClicked = true;
        var swapcourseIndex = self.courses.filter(y=>!y.isReadOnly).findIndex(x=>x.id == courseId);
        if(swapcourseIndex == self.courses.filter(y=>!y.isReadOnly).length - 1){
          self.indexButtonClicked = false;
          return
        }
        var swapcourseId = self.courses.filter(y=>!y.isReadOnly)[swapcourseIndex + 1].id;
        var onSuccess = response =>{
          self.loadData();
        }
        var onFinally = response =>{
          self.indexButtonClicked = false;
          self.$vs.notify({
              title:'Information',
              color: "success",
              text: `Order change saved`,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
        }
        self.$ajaxGet(self, `Course/MoveIndexCourse?courseId=${swapcourseId}&swapCourseId=${courseId}`  , onSuccess, onFinally);
      },
    },
    mounted() {
      var self = this;
      self.loadData();
      self.getLanguages();
      self.getClassifications();
      self.isMounted = true;
      self.showEssentialEmbeddedKnowledgeList = true;
      self.showUnitStandardsList = true;
      self.showAsessmentCriteriaList = true;
      self.showSpecificOutcomeList = true;
    },
  }

</script>
